export default {
  formattedPagination: `{{startOfPage}}-{{endOfPage}} od {{allResults}}`
};
